import {taskAddLocalRequest, taskDataRequest} from "../store/actions/task.js";
import audioFile from '../assets/audio/notify.wav'
import icon from '../assets/img/BeOn.png'
import {REACT_SOCKET_URL} from '../config.js'
import {notificationRequest, taskSocket} from "../store/actions/notification.js";
import {managerNotificationRequest} from "../store/actions/manager.js";

let socket = null;
let reconnectTimeout = null;
const playNotificationSound = () => {
    const audio = new Audio(audioFile); // ✅ Path to sound file
    audio.play().catch((error) => console.error("🔇 Error playing sound:", error));
};
const showBrowserNotification = (data) => {
    if (document.hidden && Notification.permission === "granted") {
        const notification = new Notification("BeOn New Task", {
            body: data.message,
            icon: icon,
        });

        notification.onclick = function (event) {
            event.preventDefault();
            localStorage.setItem('redirectOnFocus', `/main_employee/tasks/${data.task.id}`); // Or dynamic: `/tasks/${data.task_id}`
            window.focus();
            window.location.href = `/main_employee/tasks/${data.task.id}`; // Or dynamic: `/tasks/${data.task_id}`
        };
    }
};

export const connectSocket = (token, dispatch,) => {
    const WS_URL = `${REACT_SOCKET_URL}/ws/tasks/?token=${token}`;

    socket = new WebSocket(WS_URL);

    socket.onopen = () => {
        console.log("✅ WebSocket connected");
        dispatch(taskSocket('on'))

        if (reconnectTimeout) {
            clearTimeout(reconnectTimeout);
            reconnectTimeout = null;
        }
    };

    socket.onmessage = async (event) => {
        const data = JSON.parse(event.data);
        let creator = data.task.creator.split('/')
        if (data.task && data.message && creator[creator.length-2] !== localStorage.getItem('user_id')) {
            if (window.location.pathname === '/main_employee/tasks') {
                await dispatch(taskDataRequest(window.location.search.substring(1))); // ✅ Dispatch inside component
                dispatch(taskAddLocalRequest(data));
            }
            playNotificationSound()
            showBrowserNotification(data);
            await dispatch(notificationRequest())
            await dispatch(managerNotificationRequest(true));

        }else{
            // if (window.location.pathname === '/main_employee/tasks') {
            //     await dispatch(taskDataRequest(window.location.search.substring(1))); // ✅ Dispatch inside component
            //     await dispatch(managerNotificationRequest(true));
            // }
        }

        console.log("📩 Received task update:", data);
    };

    socket.onclose = () => {
        console.warn("⚠️ WebSocket disconnected, attempting to reconnect...");
        reconnectSocket(token, dispatch);
    };

    socket.onerror = (error) => {
        console.error("❌ WebSocket error:", error);
        dispatch(taskSocket('off'))
        socket.close();
    };
};

export const reconnectSocket = (token, dispatch) => {
    if (!reconnectTimeout) {
        reconnectTimeout = setTimeout(() => {
            console.log("♻️ Reconnecting WebSocket...");
            dispatch(taskSocket('reconnect'))

            connectSocket(token, dispatch);
        }, 3000);
    }
};

export const disconnectSocket = () => {
    if (socket) {
        socket.close();
    }
};
